<div class="row page-titles">
    <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">Terman Merril</h3>
    </div>
</div>
<app-camera *ngIf="testData.camera" [testData]="testData" [trigger]="trigger"></app-camera>
<div *ngIf="!started" class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div *ngIf="texts" #instructions class="m-b-30"></div>

                <div class="col-12">
                    <button class="btn waves-effect btn-rounded btn-info mx-2" (click)="reload()">Cancelar</button>
                    <button type="button" class="btn waves-effect waves-light btn-rounded btn-info pull-right" (click)="startTest()" data-toggle="modal" data-target="#myModal" > Realizar test </button>
    
                </div>

            </div>
        </div>
    </div>
</div>

    <div *ngIf="started" class="row justify-content-center">

        
        <div class="col-md-10">
            <div class="card p-20">
                <button class="right-side-toggle waves-effect waves-light btn-inverse btn">{{timers[selectedSerie]/60-1-minutes}}:{{60-seconds-1 | number:'2.0'}}</button>
                <div class="card-body">
                   <div *ngIf="selectedSerie==1" >
                        <div class="row">
                            <div *ngIf="showingInstructions">
                                <h2>Serie 1</h2>
                                <div *ngIf="texts" #instructions1 [innerText]="texts.termanInstructions1" class="m-b-30"></div>
                                <button class="btn btn-success waves-effect" (click)="startCounter()">Comenzar</button>
                            </div>
                            <div *ngFor="let question of questions; index as i" class="col-md-12">
                                <div *ngIf="question.serie==1&&!showingInstructions" class="col-md-12">
                                    <h3>{{question.title}}</h3>
                                    <div>
                                        <div class="form-check">
                                            <label class="custom-control custom-radio">
                                                <input id="radio1" [name]="i" value="opcA"  [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">{{question.opcA.text}}</span>
                                            </label>
                                        </div>
    
                                    </div>
                                    <div >
                                    <div class="form-check">
                                        <label class="custom-control custom-radio">
                                            <input id="radio2" [name]="i" value="opcB" [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">{{question.opcB.text}}</span>
                                        </label>
                                    </div>
    
                                </div>
                                <div >
                                    <div class="form-check">
                                        <label class="custom-control custom-radio">
                                            <input id="radio3" [name]="i" value="opcC" [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">{{question.opcC.text}}</span>
                                        </label>
                                    </div>
    
                                </div>
                                <div >
                                    <div class="form-check">
                                        <label class="custom-control custom-radio">
                                            <input id="radio4" [name]="i" value="opcD" [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">{{question.opcD.text}}</span>
                                        </label>
                                    </div>
    
                                </div>
                                </div>
                            </div>
                            
                        </div>
   

                   </div>

                   <div *ngIf="selectedSerie==2" >
                        <div class="row">
                            <div *ngIf="showingInstructions">
                                <h2>Serie 2</h2>
                                <div *ngIf="texts" [innerText]="texts.termanInstructions2" class="m-b-30"></div>
                                <button class="btn btn-success waves-effect" (click)="startCounter()">Comenzar</button>
                            </div>
                            <div *ngFor="let question of questions; index as i" class="col-md-12">
                                <div *ngIf="question.serie==2&&!showingInstructions" class="col-md-12">
                                    <h3>{{question.title}}</h3>
                                    <div>
                                        <div class="form-check">
                                            <label class="custom-control custom-radio">
                                                <input id="radio1" [name]="i" value="opcA" [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">{{question.opcA.text}}</span>
                                            </label>
                                        </div>

                                    </div>
                                    <div >
                                    <div class="form-check">
                                        <label class="custom-control custom-radio">
                                            <input id="radio2" [name]="i" value="opcB" [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">{{question.opcB.text}}</span>
                                        </label>
                                    </div>

                                </div>
                                <div >
                                    <div class="form-check">
                                        <label class="custom-control custom-radio">
                                            <input id="radio3" [name]="i" value="opcC" [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">{{question.opcC.text}}</span>
                                        </label>
                                    </div>

                                </div>
                                </div>
                            </div>
                            
                        </div>


                    </div>

                    <div *ngIf="selectedSerie==3" >
                        <div class="row">
                            <div *ngIf="showingInstructions">
                                <h2>Serie 3</h2>
                                <div *ngIf="texts" [innerText]="texts.termanInstructions3" class="m-b-30"></div>
                                <button class="btn btn-success waves-effect" (click)="startCounter()">Comenzar</button>
                            
                            </div>
                            <div *ngFor="let question of questions; index as i" class="col-md-12">
                                <div *ngIf="question.serie==3&&!showingInstructions" class="col-md-12">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <form class="form-material m-t-40">
                                                <div class="form-group">
                                                    <label>{{question.pair.text}}</label>
                                                    <input type="text" (change)="setLastSelected(i)" [ngModelOptions]="{standalone: true}" [(ngModel)]="selected[i]" class="form-control form-control-line" placeholder="i / o"> </div>
                                            </form>
                                        </div>

                                    </div>
                            
                                </div>
                            </div>
                            
                        </div>
          
                    </div>

                    <div *ngIf="selectedSerie==4" >
                        <div class="row">
                            <div *ngIf="showingInstructions">
    
                                <h2>Serie 4</h2>
                                <div *ngIf="texts" [innerText]="texts.termanInstructions4" class="m-b-30"></div>
                                <button class="btn btn-success waves-effect" (click)="startCounter()">Comenzar</button>
                            </div>

                            <div *ngFor="let question of questions; index as i" class="col-md-12">
                                <div *ngIf="question.serie==4&&!showingInstructions" class="col-md-12">
                                    <h3>{{question.title}}</h3>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label>{{question.doubleSelection.opcA.text}}</label>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="switch">
                                                <label>
                                                    <input type="checkbox" [disabled]="qnts[i]>=2&&!doubleSelection[i].opcA" (ngModelChange)="checkQnt(i,$event)" [(ngModel)]="doubleSelection[i].opcA" ><span class="lever"></span></label>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="row">

                                        <div class="col-md-4">
                                            <label>{{question.doubleSelection.opcB.text}}</label>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="switch">
                                                <label>
                                                    <input type="checkbox" [disabled]="qnts[i]>=2&&!doubleSelection[i].opcB" (ngModelChange)="checkQnt(i,$event)" [(ngModel)]="doubleSelection[i].opcB" ><span class="lever"></span></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">

                                        <div class="col-md-4">
                                            <label>{{question.doubleSelection.opcC.text}}</label>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="switch">
                                                <label>
                                                    <input type="checkbox" [disabled]="qnts[i]>=2&&!doubleSelection[i].opcC" (ngModelChange)="checkQnt(i,$event)" [(ngModel)]="doubleSelection[i].opcC" ><span class="lever"></span></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">

                                        <div class="col-md-4">
                                            <label>{{question.doubleSelection.opcD.text}}</label>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="switch">
                                                <label>
                                                    <input type="checkbox" [disabled]="qnts[i]>=2&&!doubleSelection[i].opcD" (ngModelChange)="checkQnt(i,$event)" [(ngModel)]="doubleSelection[i].opcD" ><span class="lever"></span></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">

                                        <div class="col-md-4">
                                            <label>{{question.doubleSelection.opcE.text}}</label>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="switch">
                                                <label>
                                                    <input type="checkbox" [disabled]="qnts[i]>=2&&!doubleSelection[i].opcE" (ngModelChange)="checkQnt(i,$event)" [(ngModel)]="doubleSelection[i].opcE" ><span class="lever"></span></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <br>
                            
                        </div>


                   </div>
                    <div *ngIf="selectedSerie==5" >
                        <div class="row">
                            <div *ngIf="showingInstructions">
                                <h2>Serie 5</h2>
                                <div *ngIf="texts" [innerText]="texts.termanInstructions5" class="m-b-30"></div>
                                <button class="btn btn-success waves-effect" (click)="startCounter()">Comenzar</button>

                            </div>
                            <div *ngFor="let question of questions; index as i" class="col-md-12">
                                <div *ngIf="question.serie==5&&!showingInstructions" class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <form class="form-material m-t-40">
                                                <div class="form-group">
                                                    <label>{{question.title}}</label>
                                                    <input type="number"  [ngModelOptions]="{standalone: true}" [(ngModel)]="selected[i]" class="form-control form-control-line" value="valor"> 
                                                </div>
                                            </form>
                                        </div>

                                    </div>
                            
                                </div>
                            </div>
                            
                        </div>

                    </div>
                    <div *ngIf="selectedSerie==6" >
                        <div class="row">
                            <div *ngIf="showingInstructions">
                                <h2>Serie 6</h2>
                                <div *ngIf="texts" [innerText]="texts.termanInstructions6" class="m-b-30"></div>
                                <button class="btn btn-success waves-effect" (click)="startCounter()">Comenzar</button>

                            </div>
                            <div *ngFor="let question of questions; index as i" class="col-md-12">
                                <div *ngIf="question.serie==6&&!showingInstructions" class="col-md-12">
                                    <div class="row">

                                        <div class="col-md-8">
                                            <label>{{question.title}}</label>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="switch">
                                                <label>No
                                                    <input (change)="setLastSelected(i)" type="checkbox" [(ngModel)]="booleanArray[i]" ><span class="lever"></span>Si</label>
                                            </div>
                                        </div>
                                    </div>
                            
                                </div>
                            </div>
                            
                        </div>


                    </div>

                    <div *ngIf="selectedSerie==7" >
                        <div class="row">
                            <div *ngIf="showingInstructions">
                                <h2>Serie 7</h2>
                                <div *ngIf="texts" [innerText]="texts.termanInstructions7" class="m-b-30"></div>
                                <button class="btn btn-success waves-effect" (click)="startCounter()">Comenzar</button>

                            </div>
                            <div *ngFor="let question of questions; index as i" class="col-md-12">
                                <div *ngIf="question.serie==7&&!showingInstructions" class="col-md-12">
                                    <h3>{{question.title}}</h3>
                                    <div>
                                        <div class="form-check">
                                            <label class="custom-control custom-radio">
                                                <input id="radio1" [name]="i" value="opcA" [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">{{question.opcA.text}}</span>
                                            </label>
                                        </div>
    
                                    </div>
                                    <div >
                                    <div class="form-check">
                                        <label class="custom-control custom-radio">
                                            <input id="radio2" [name]="i" value="opcB" [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">{{question.opcB.text}}</span>
                                        </label>
                                    </div>
    
                                </div>
                                <div >
                                    <div class="form-check">
                                        <label class="custom-control custom-radio">
                                            <input id="radio3" [name]="i" value="opcC" [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">{{question.opcC.text}}</span>
                                        </label>
                                    </div>
    
                                </div>
                                <div >
                                    <div class="form-check">
                                        <label class="custom-control custom-radio">
                                            <input id="radio4" [name]="i" value="opcD" [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">{{question.opcD.text}}</span>
                                        </label>
                                    </div>
    
                                </div>
                                </div>
                            </div>
                            <br><br>
                            
                        </div>

                   </div>

                   <div *ngIf="selectedSerie==8" >
                    <div class="row">
                        <div *ngIf="showingInstructions">
                            <h2>Serie 8</h2>
                            <div *ngIf="texts" [innerText]="texts.termanInstructions8" class="m-b-30"></div>
                            <button class="btn btn-success waves-effect" (click)="startCounter()">Comenzar</button>

                        </div>
                        <div *ngFor="let question of questions; index as i" class="col-md-12">
                            <div *ngIf="question.serie==8&&!showingInstructions" class="col-md-12">
                                <div class="row">

                                    <div class="col-md-8">
                                        <label>{{question.title}}</label>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="switch">
                                            <label>Falso
                                                <input (change)="setLastSelected(i)" type="checkbox" [(ngModel)]="booleanArray[i]" ><span class="lever"></span>Verdadero</label>
                                        </div>
                                    </div>
                                </div>
                        
                            </div>
                       
                        </div>
                        
                    </div>


                </div>

                <div *ngIf="selectedSerie==9" >
                    <div class="row">
                        <div *ngIf="showingInstructions">
                            <h2>Serie 9</h2>
                            <div *ngIf="texts" [innerText]="texts.termanInstructions9" class="m-b-30"></div>
                            <button class="btn btn-success waves-effect" (click)="startCounter()">Comenzar</button>

                        </div>
                        <div *ngFor="let question of questions; index as i" class="col-md-12">
                            <div *ngIf="question.serie==9&&!showingInstructions" class="col-md-12">
                                <h3>{{question.title}}</h3>
                                <div>
                                    <div class="form-check">
                                        <label class="custom-control custom-radio">
                                            <input id="radio1" [name]="i" value="opcA" [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">{{question.opcA.text}}</span>
                                        </label>
                                    </div>

                                </div>
                                <div >
                                <div class="form-check">
                                    <label class="custom-control custom-radio">
                                        <input id="radio2" [name]="i" value="opcB" [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                        <span class="custom-control-indicator"></span>
                                        <span class="custom-control-description">{{question.opcB.text}}</span>
                                    </label>
                                </div>

                            </div>
                            <div >
                                <div class="form-check">
                                    <label class="custom-control custom-radio">
                                        <input id="radio3" [name]="i" value="opcC" [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                        <span class="custom-control-indicator"></span>
                                        <span class="custom-control-description">{{question.opcC.text}}</span>
                                    </label>
                                </div>

                            </div>
                            <div >
                                <div class="form-check">
                                    <label class="custom-control custom-radio">
                                        <input id="radio4" [name]="i" value="opcD" [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                        <span class="custom-control-indicator"></span>
                                        <span class="custom-control-description">{{question.opcD.text}}</span>
                                    </label>
                                </div>

                            </div>
                            <div >
                                <div class="form-check">
                                    <label class="custom-control custom-radio">
                                        <input id="radio4" [name]="i" value="opcE" [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                        <span class="custom-control-indicator"></span>
                                        <span class="custom-control-description">{{question.opcE.text}}</span>
                                    </label>
                                </div>

                            </div>
                            <hr>
                            </div>
                        </div>
                        
                    </div>


               </div>

               <div *ngIf="selectedSerie==10" >
                <div class="row">
                    <div *ngIf="showingInstructions">
                        <h2>Serie 10</h2>
                        <div *ngIf="texts" [innerText]="texts.termanInstructions10" class="m-b-30"></div>
                        <button class="btn btn-success waves-effect" (click)="startCounter()">Comenzar</button>

                    </div>
                    <div *ngFor="let question of questions; index as i" class="col-md-12">
                        <div *ngIf="question.serie==10&&!showingInstructions" class="col-md-12">
                            <div class="row">
                                <div class="col-sm-12">
                                    <form class="form-material m-t-40">
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <label>{{question.title}}</label>

                                                </div>
                                                <div class="col-md-3">
                                                    <input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="doubleText[i][1]" class="form-control form-control-line" placeholder="Primer valor"> 

                                                </div>
                                                <div class="col-md-3">
                                                    <input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="doubleText[i][2]" class="form-control form-control-line" placeholder="Segundo valor"> 

                                                </div>
                                            </div>

                                        </div>
                                    </form>
                                </div>

                            </div>
                    
                        </div>
                    </div>
                    
                </div>


            </div>

            <!-- <button *ngIf="started && !showingInstructions" type="button" class="btn waves-effect waves-light btn-rounded btn-info pull-right" (click)="handleNextSection()" data-toggle="modal" data-target="#myModal" > Siguiente </button> -->





                </div>
            </div>
        </div>
    </div>
